export function fallbackCopy(text) {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'fixed'
    textarea.style.left = '-9999px'
    textarea.style.top = '0'

    document.body.appendChild(textarea)
    textarea.select()
    textarea.setSelectionRange(0, textarea.value.length)

    let success = false
    try {
        success = document.execCommand('copy')
    } catch (err) {
        console.error('execCommand 复制异常：', err)
    } finally {
        document.body.removeChild(textarea)
    }

    if (!success) throw new Error('execCommand 复制失败')
}

/**
 * 复制文本
 * @param {string|number} content
 * @returns {Promise<boolean>}
 */
export async function copyText(content) {
    if (content === undefined || content === null) return false
    const text = String(content)
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text)
        } else {
            fallbackCopy(text)
        }
        return true
    } catch (err) {
        console.error('复制失败：', err)
        return false
    }
}